import type { LogContext } from './types';

let runtimeContext: Partial<LogContext> = {};

export function getRuntimeLogContext(): Partial<LogContext> {
  return runtimeContext;
}

export function setRuntimeLogContext(context: Partial<LogContext>): void {
  const nextContext: Record<string, unknown> = { ...runtimeContext };

  for (const [key, value] of Object.entries(context)) {
    if (value === undefined) {
      delete nextContext[key];
      continue;
    }

    nextContext[key] = value;
  }

  runtimeContext = nextContext as Partial<LogContext>;
}

export function clearRuntimeLogContext(keys?: string[]): void {
  if (!keys || keys.length === 0) {
    runtimeContext = {};
    return;
  }

  const nextContext: Record<string, unknown> = { ...runtimeContext };

  for (const key of keys) {
    delete nextContext[key];
  }

  runtimeContext = nextContext as Partial<LogContext>;
}
